/** «1» … «9», y «9+» a partir de diez; vacío si no hay ninguno. */
export function textoDeSinLeer(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return "";
  return n > 9 ? "9+" : String(Math.floor(n));
}
